import React from "react";
import "./Curriculum.css";

const Curriculum = () => {
  return (
    <section className="page-section">
      <h1>Curriculum</h1>

      <table className="curriculum-table">
        <thead>
          <tr>
            <th>Topic</th>
            <th>Overview</th>
          </tr>
        </thead>
        <tbody>

          <tr>
            <td>Carnatic Basics</td>
            <td>
              <ul>
                <li>Swaravali</li>
                <li>Geethams</li>
                <li>Swarajathi</li>
                <li>Voice Training &amp; Breath Control</li>
                <li>Introduction to Basic Taalams &amp; Rhythms</li>
              </ul>
            </td>
          </tr>

         <tr>
            <td>Carnatic Intermediate</td>
            <td>
              <ul>
                <li>Intermediate Voice Training</li>
                <li>Varnams (including Pada Varnams) in Adi &amp; Ata Talam</li>
                <li>Kritis</li>
              </ul>
            </td>
          </tr>


          <tr>
            <td>Carnatic Advanced</td>
            <td>
              <ul>
                <li>Advanced Kritis</li>
                <li>Raga Expansion &amp; Development</li>
                <li>Swara Improvisation</li>
                <li>Concert Preparation</li>
              </ul>
            </td>
          </tr>

          {/* 4. Prayer Bhajans */}
          <tr>
            <td>Prayer Bhajans</td>
            <td>
              <ul>
                <li>Bhajans suitable for children &amp; young adults</li>
                <li>Focus on auspicious occasions &amp; devotional themes</li>
                <li>Instruction tailored to different age groups</li>
              </ul>
            </td>
          </tr>

          {/* 5. Thyagaraja Pancharatna Kritis */}
          <tr>
            <td>Thyagaraja Pancharatna Kritis</td>
            <td>
              <ul>
                <li>Detailed study of the five Pancharatna Kritis by Saint Thyagaraja</li>
                <li>Emphasis on Bhava (expression) &amp; Laya (rhythm)</li>
                <li>Taught progressively in both individual &amp; group settings</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export default Curriculum;
